module.exports = __webpack_public_path__ + "static/img/yuwu-bg.a1f2fb4e.png";